import Home from "../modules/rootModule/views/Home";
import Login from "../modules/rootModule/views/Login";
import LoginWithSignUp from "../modules/rootModule/views/LoginWithSignup"

export default [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/login-signup",
    name: "login-with-signup",
    component: LoginWithSignUp
  }
];
